export default __webpack_public_path__ + "static/media/eye_icon.6e05e2ba.svg";